<template>
<div class="chapter">
<div class="inner_page">
<div class="_--black-opening-page">
<p class="_PN _idGenParaOverride-1" id="_idParaDest-5"><span epub:type="pagebreak" id="page5" title="5"><a id="_idTextAnchor002"></a>THE KITCHEN PHARMACY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HKWH-1.vue?2a8cdbc6